<template>
  <div>
    <hg-dialog :title="title" :width="600" :height="400" :visible.sync="show" @close="handleClose">
      <el-form :model="data"  size="mini" :rules="rules" ref="ruleForm" label-width="100px" class="add-box">
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="data.name" maxlength="50" :disabled="!isEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="是否启用" prop="select">
              <el-switch
                v-model="statu"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :disabled="!isEdit"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="权限管理">
          <div class="authority-box">
            <authority
              ref="authorityTree"
              :authorityTree="authorityTree"
              @checkedArr="checkedArr"
              :disabled="!isEdit"
              :functionId="data.functionId"
              :resourceId="data.resourceId"></authority>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="hg-dialog-footer">
        <el-button v-if="isEdit" type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button v-else type="primary" @click="edit" size="small" icon="el-hg-icon-edit">修 改</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>
import authority from '../comm/authority';
import HgDialog from '@/components/dialog';

export default {
  name: 'edit',
  components: {
    authority,
    HgDialog,
  },
  props: {
    data: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
    authorityTree: {
      type: Array,
    },
    title: {
      String,
      default: '角色详情',
    },
    isEdit: {
      String,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: '请输入角色名称',
            trigger: 'blur',
          },
        ],
      },
      dataForm: {
        name: '',
        id: '',
        functionId: '',
        resourceId: '',
        updateFlg: 'update',
      },
      statu: false,
    };
  },
  methods: {
    edit() {
      this.transforTree();
      this.$emit('update:isEdit', true);
      this.$emit('update:title', '角色编辑');
    },
    checkedArr(params) {
      this.data.functionId = params.functionId.join(',');
      this.data.resourceId = params.resourceId.join(',');
    },
    transforTree() {
    },
    submit() {
      const checkedArr = this.$refs.authorityTree.getCheckedNodes(false, true);
      let functionId = [];
      let resourceId = [];
      checkedArr.forEach(data => {
        if (!data.sourceFlag) {
          functionId.push(data.id);
        }
        else {
          resourceId.push(data.id);
        }
      });
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.dataForm.name = this.data.name;
          this.dataForm.functionId = functionId.join(',');
          this.dataForm.resourceId = resourceId.join(',');
          this.dataForm.id = this.data.id;
          this.dataForm.state = this.statu ? 1 : 0;
          this.saveRole();
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    async saveRole() {
      const res = await this.$services.postJson({
        type: 'ROLEMANGEMENT',
        url: 'saveRole',
        params: JSON.parse(JSON.stringify(this.dataForm)),
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('refresh');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.$emit('close');
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
        this.statu = this.data.statu;
      }
    },
  },
};
</script>
